import { aiToolsDownloadContainerFile } from "../../api/api";
import { AiDealAnalysisResult, AiDealAnalysisResultSchema } from "../../types";
import { mark } from "./runMetrics";

type LoadResult =
  | { ok: true, data: AiDealAnalysisResult }
  | { ok: false, error: string };

const cache = new Map<string, AiDealAnalysisResult>();

export const getCachedAnalysisResult = (fileId: string) => cache.get(fileId);

export const loadAnalysisResult = async (fileId: string, skill?: string): Promise<LoadResult> => {
  const cached = cache.get(fileId);

  if (cached) {
    return { ok: true, data: cached };
  }

  const from = Date.now();
  const res = await aiToolsDownloadContainerFile(fileId);

  mark(skill, "file:download", { ms: Date.now() - from, ok: res.success !== false });

  switch (res.success) {
    case false:
      return { ok: false, error: `the file could not be downloaded (${res.message})` };

    case true:
      break;
  }

  let raw: unknown;

  try {
    raw = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
  }
  catch {
    return { ok: false, error: "the file does not contain valid JSON" };
  }

  const parsed = AiDealAnalysisResultSchema.safeParse(raw);

  if (!parsed.success) {
    const issues = parsed.error.issues
      .slice(0, 10)
      .map(i => `${i.path.join(".") || "root"}: ${i.message}`)
      .join("; ");

    return { ok: false, error: `the file does not match the analysis schema (${issues})` };
  }

  mark(skill, "file:parsed", {
    length: typeof res.data === "string" ? res.data.length : null,
    findings: parsed.data.findings.length
  });

  cache.set(fileId, parsed.data);

  return { ok: true, data: parsed.data };
}
